import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CardActionButton, CardActionCheckbox } from "@bluframe/mightychroma-mightytool-ui";
import Gather from "components/Cards/Actions/Gather";
const Actions = ({ listButtonProps, onlyNewProps, serviceName }) => (_jsxs(_Fragment, { children: [_jsx(Gather, { serviceName: serviceName, serviceType: "reviews" }), _jsx(CardActionButton, { ...listButtonProps }), _jsx(CardActionCheckbox, { ...onlyNewProps })] }));
export default Actions;
